import { StickyNote } from 'lucide-react'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { DetailSection } from './DetailSection'
import { type buildTimeline, NoteRow } from './InvestigationDossier'

export function InvestigationNotesCard({
  timeline,
  composer,
}: {
  timeline: ReturnType<typeof buildTimeline>
  /** Writes a new note, above the timeline; none where notes are only read. */
  composer?: ReactNode
}) {
  const { t } = useTranslation()
  return (
    <DetailSection
      icon={<StickyNote className="size-4" />}
      title={t('investigations.page.featured.notesTimeline')}
      meta={<span className="font-mono text-xs text-muted-foreground">{timeline.length}</span>}
    >
      {composer && <div className="mb-4">{composer}</div>}
      {timeline.length === 0 ? (
        <p className="py-4 text-sm italic text-muted-foreground">
          {t('investigations.page.featured.noNotes')}
        </p>
      ) : (
        <div>
          {timeline.map(entry => (
            <NoteRow key={entry.id} entry={entry} />
          ))}
        </div>
      )}
    </DetailSection>
  )
}
